<template>
  <div class="cancel-modal-component">
    <hi-dialog class="cancel-dialog" title="Cancel Plan" @close="closeDialog">
      <div
        v-if="showBackIcon"
        @click="backClick"
        slot="left"
        class="back-icon"
      ></div>
      <div class="cancel-page">
        <div class="main-container">
          <div class="status-container">
            <hi-progress :array="banner"></hi-progress>
          </div>
          <div v-if="type === 'feedback'" class="feedback-page">
            <div class="des1">
              We have a quick question that we hope you'll answer to help us
              make Apphi better:
            </div>
            <div class="des2">What made you cancel?</div>
            <textarea
              v-model="feedback"
              :class="{ error: showMsg }"
              class="feedback-text"
              placeholder="Just type here and let us know. We’d really appreciate it."
            ></textarea>
            <div class="msg">
              <template v-if="showMsg">This field is required.</template>
            </div>
            <div class="current-user-container">
              <div class="title">Apphi Account</div>
              <div class="username">{{ user.email }}</div>
            </div>
          </div>
          <div v-if="type === 'detail'" class="detail-page">
            <div class="title">Cancelling your plan means:</div>
            <div class="des des1">
              <div class="icon"></div>
              <div class="text">
                You’ll lose schedules on all your schedules.
              </div>
            </div>
            <div class="des des2">
              <div class="icon"></div>
              <div class="text">
                <div>You’ll lose access to these features:</div>
                <div class="plan">
                  <div
                    v-for="item in currentPlanDes"
                    :key="item.text"
                    class="des-item"
                  >
                    <div class="detail-icon"></div>
                    <div class="detail-text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="type === 'offer'" class="offer-page">
            <div class="title">
              Before you decide to cancel, consider this offer:
            </div>
            <div class="plan-info-container">
              <div class="des1">
                Get your next month {{ user.plan.cancelInfo.discount }} off and
                save
              </div>
              <div class="price-des">
                <span class="price-num">{{ user.plan.cancelInfo.save }}</span>
              </div>
              <div class="des2">Regular</div>
              <div class="price-des">
                <span class="price-num overline"
                  >{{ user.plan.cancelInfo.regular }}/month</span
                >
              </div>
              <div class="des2">Your price for the next month</div>
              <div class="price-des">
                <span class="price-num">{{ user.plan.cancelInfo.price }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container">
          <div class="button" v-show="showContinueBtn" @click="nextClick">
            Continue
          </div>
          <div class="button big" v-if="showCancelBtn" @click="cancelClick">
            Cancel plan
          </div>
          <div
            class="button big full"
            v-if="showAcceptBtn"
            @click="acceptClick"
          >
            Accept offer
          </div>
        </div>
      </div>
    </hi-dialog>
  </div>
</template>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import hiProgress from "./Progress";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_USER_PLAN_LIST_SIMPLE,
} from "../../../../store/mutation-types";
import {
  cancel,
  sendFeedback,
  unsubscription,
} from "../../../../service/payment";
import { showErrorMsg } from "../../../../utils/errors";
export default {
  name: "CancelModal",
  components: { hiDialog, hiProgress },
  data() {
    return {
      showMsg: false, // 是否展示错误信息
      feedback: "", // 填写的意见
      type: "feedback", // 当前所处的页面feedback 反馈页面， detail详情页面 offer优惠页面
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
    }),
    showBackIcon() {
      // 只要不是feedback页面都显示后退按钮
      return this.type !== "feedback";
    },
    /**
     * 显示继续按钮
     */
    showContinueBtn() {
      // feedback必显示
      if (this.type === "feedback") {
        return true;
      }
      // offer页面必然不显示
      if (this.type === "offer") {
        return false;
      }
      // detail页面如果有优惠则显示
      if (this.type === "detail") {
        return this.unsubscription;
      }
      return false;
    },
    /**
     * 显示取消按钮
     */
    showCancelBtn() {
      // offer页面必然显示
      if (this.type === "offer") {
        return true;
      }
      // 详情页面如果没有优惠则直接显示取消
      if (this.type === "detail") {
        return !this.unsubscription;
      }
      return false;
    },
    showAcceptBtn() {
      // offer页面必然显示
      if (this.type === "offer") {
        return true;
      }
      // 其他页面都不显示
      return false;
    },
    unsubscription() {
      return this.user.unsubscription;
    },
    banner() {
      if (this.type === "feedback") {
        // 如果存在优惠则显示offer，不存在则直接显示detail
        const list = [
          { text: "Feedback", active: true },
          { text: "Detail", active: false },
        ];
        if (this.unsubscription) {
          list.push({ text: "Offer", active: false });
        }
        return list;
      } else if (this.type === "detail") {
        // 如果存在优惠则显示offer，不存在则直接显示detail
        const list = [
          { text: "Feedback", active: true },
          { text: "Detail", active: true },
        ];
        if (this.unsubscription) {
          list.push({ text: "Offer", active: false });
        }
        return list;
      }
      return [
        { text: "Feedback", active: true },
        { text: "Detail", active: true },
        { text: "Offer", active: true },
      ];
    },
    currentPlanDes() {
      const current = this.user.plan.cancelInfo;
      if (current) {
        const des = current.desc.replace(/✓/g, "✗");
        const desArr = des.split("\n");
        let result = [];
        desArr.forEach((row) => {
          const iconIndex = [...row].findIndex((r) => r === "✓" || r === "✗");
          result.push({
            icon: row.substr(0, iconIndex + 1).trim(),
            // eslint-disable-next-line
            text: row
              .substr(iconIndex + 1)
              .replace(/  /g, "")
              .trim(), // 玄学过滤 千万不要动，否则pt语言会有问题
            forbid: [...row].findIndex((r) => r === "✗") !== -1,
          });
        });
        return result;
      }
      return [];
    },
  },
  methods: {
    backClick() {
      if (this.type === "detail") {
        this.type = "feedback";
      } else if (this.type === "offer") {
        this.type = "detail";
      }
    },
    nextClick() {
      // 判断当前feddback是否填写
      if (!this.feedback) {
        this.showMsg = true;
        return;
      }
      this.showMsg = false;
      if (this.type === "detail") {
        // 如果详情可以看到按钮则说明肯定需要
        this.type = "offer";
      } else {
        // 这种只能是feedback页面，直接跳详情页
        this.type = "detail";
      }
    },
    async cancelClick() {
      const loading = this.$loading();
      try {
        await cancel({ feedback: this.feedback });
        this.$router.push({ name: "PaymentHistoryPage" });
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    async acceptClick() {
      const loading = this.$loading();
      try {
        await unsubscription({ feedback: this.feedback });
        this.$alert.show({
          cancelText: "", // 不知道什么鬼。。总是被自动设置成cancel。。
          title: "Congrats",
          text: `Your plan remains active. Your next month is ${this.user.plan.cancelInfo.price}`,
          yesText: this.$t("common.ok"),
        });
        this.$emit("close");
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    async closeDialog() {
      if (this.feedback) {
        const loading = this.$loading();
        try {
          await sendFeedback({ feedback: this.feedback });
        } catch (e) {
          showErrorMsg(e);
        } finally {
          loading.close();
        }
      }
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.cancel-modal-component {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .cancel-dialog {
    width: 480px;
    .back-icon {
      height: 17px;
      width: 10px;
      background-size: contain;
      background-image: url("../../../../../public/images/cancel/icon_left@3x.png");
      cursor: pointer;
      &:hover {
        opacity: 0.3;
      }
    }
    .cancel-page {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 430px;
      .main-container {
        display: flex;
        overflow: scroll;
        flex: 1;
        flex-direction: column;
        .status-container {
          padding: 24px 70px;
          border-bottom: 1px solid #e6e6e6;
        }
        .feedback-page {
          padding: 20px;
          line-height: 1.3;
          .des1 {
            font-size: 16px;
          }
          .des2 {
            font-size: 16px;
            margin-top: 20px;
            font-weight: 500;
          }
          .feedback-text {
            resize: none;
            width: calc(~"100% - 35px");
            background: #f5f5f5;
            border: 1px solid #d2d2d2;
            height: 162px;
            margin-top: 10px;
            border-radius: 3px;
            font-size: 14px;
            padding: 10px 16px;
            &.error {
              border-color: #e02020;
            }
          }
          .msg {
            color: #e02020;
            font-size: 14px;
          }
          .current-user-container {
            margin-top: 20px;
            font-size: 14px;
            .title {
            }
            .username {
            }
          }
        }
        .detail-page {
          padding: 20px 20px 45px 20px;
          .title {
            font-size: 20px;
            font-weight: 500;
          }
          .des {
            display: flex;
            font-size: 16px;
            .icon {
              background-image: url("../../../../../public/images/cancel/icon@3x.png");
              height: 28px;
              width: 28px;
              background-size: contain;
              position: relative;
              bottom: 4px;
            }
            .text {
              margin-left: 17px;
              white-space: pre-line;
              font-weight: 600;
              .plan {
                margin-top: 5px;
                font-weight: normal;
                .des-item {
                  display: flex;
                  align-items: center;
                  font-size: 13px;
                  line-height: 23px;
                  .detail-icon {
                    background-image: url("../../../../../public/images/cancel/✗@3x.png");
                    width: 10px;
                    height: 12px;
                    background-size: contain;
                    margin-right: 6px;
                  }
                  .detail-text {
                    white-space: pre-wrap;
                  }
                }
              }
            }
          }
          .des1 {
            margin-top: 30px;
          }
          .des2 {
            margin-top: 17px;
          }
        }
        .offer-page {
          padding: 20px 20px 45px 20px;
          .title {
            font-size: 20px;
            font-weight: 500;
          }
          .plan-info-container {
            background: #db45ae;
            padding: 20px 22px;
            border-radius: 6px;
            color: white;
            margin-top: 20px;
            .des1 {
              font-size: 20px;
              font-weight: 500;
            }
            .des2 {
              font-size: 16px;
              margin-top: 13px;
            }
            .price-num {
              font-weight: 700;
              &.overline {
                text-decoration: line-through;
              }
            }
            .price-des {
              margin-top: 5px;
              font-size: 20px;
            }
          }
        }
      }
      .bottom-container {
        height: 65px;
        border-top: 1px solid #d2d2d2;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 20px;
        background: white;
        .button {
          font-size: 16px;
          height: 36px;
          width: 98px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #e02020;
          color: #e02020;
          border-radius: 4px;
          margin-left: 15px;
          cursor: pointer;
          &.big {
            width: 140px;
          }
          &.full {
            background: #e02020;
            color: white;
          }
          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }
}
</style>
